import * as React from 'react';
import React__default, { useRef, useState, useEffect } from 'react';

var classnames$1 = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames$1));

var classnames = classnames$1.exports;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".button-module_button__RiZd- {\n  align-items: center;\n  border-radius: 2px;\n  cursor: pointer;\n  display: flex;\n  font-family: benton-sans, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  justify-content: center;\n  letter-spacing: 0.25px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n}\n.button-module_button__RiZd-:focus {\n  outline-color: #317aad;\n  outline-offset: 1px;\n  outline-style: auto;\n  outline-width: 2px;\n}\n.button-module_button__RiZd-:disabled {\n  cursor: default;\n  opacity: 0.2;\n}\n.button-module_buttonLarge__dZdJ6 {\n\n  height: 48px;\n  min-width: 134px;\n}\n.button-module_buttonLargeIcon__5xUfs {\n\n  height: 48px;\n  padding: 0px;\n  width: 48px;\n}\n.button-module_buttonRegular__6-2hG {\n\n  height: 40px;\n  min-width: 102px;\n}\n.button-module_buttonRegularIcon__DTRqn {\n\n  height: 40px;\n  padding: 0px;\n  width: 40px;\n}\n.button-module_buttonSmall__4v4PR {\n\n  height: 32px;\n  min-width: 70px;\n}\n.button-module_buttonSmallIcon__NrRV0 {\n\n  height: 32px;\n  padding: 0px;\n  width: 32px;\n}\n.button-module_buttonPrimary__tlsxX {\n  border-style: solid;\n  border-width: 1px;\n}\n.button-module_buttonPrimaryNavy__gutLQ {\n  background: #00253e;\n\n  border-color: #00253e;\n  color: #ffffff;\n}\n.button-module_buttonPrimaryNavy__gutLQ:hover:enabled {\n  background: #23448d;\n  border-color: #23448d;\n}\n.button-module_buttonPrimaryNavy__gutLQ:active:enabled {\n  background: #06235f;\n  border-color: #06235f;\n}\n.button-module_buttonPrimaryNavyActive__j-gy- {\n  background: #06235f;\n  border-color: #06235f;\n}\n.button-module_buttonPrimaryGold__H33XD {\n  background: #c29b40;\n\n  border-color: #c29b40;\n  color: #00253e;\n}\n.button-module_buttonPrimaryGold__H33XD:hover:enabled {\n  background: #a68940;\n  border-color: #a68940;\n}\n.button-module_buttonPrimaryGold__H33XD:active:enabled {\n  background: #c29b40;\n  border-color: #c29b40;\n}\n.button-module_buttonPrimaryGoldActive__f-RQl {\n  background: #c29b40;\n  border-color: #c29b40;\n}\n.button-module_buttonPrimaryDanger__fltR6 {\n  background: #dd2415;\n\n  border-color: #dd2415;\n  color: #ffffff;\n}\n.button-module_buttonPrimaryDanger__fltR6:hover:enabled {\n  background: #a81e13;\n  border-color: #a81e13;\n}\n.button-module_buttonPrimaryDanger__fltR6:active:enabled {\n  background: #dd2415;\n  border-color: #dd2415;\n}\n.button-module_buttonPrimaryDangerActive__ASUin {\n  background: #dd2415;\n  border-color: #dd2415;\n}\n.button-module_buttonSecondary__Svb9S {\n  background: transparent;\n  border: 1px solid #cecece;\n  color: #00253e;\n}\n.button-module_buttonSecondary__Svb9S:hover:enabled {\n  border-color: #23448d;\n  color: #23448d;\n}\n.button-module_buttonSecondary__Svb9S:active:enabled {\n  border-color: #00253e;\n  color: #00253e;\n}\n.button-module_buttonSecondaryActive__f4cwx {\n  border-color: #00253e;\n  color: #00253e;\n}\n.button-module_buttonTertiary__ApQ-M {\n  background: transparent;\n  border: none;\n  color: #00253e;\n}\n.button-module_buttonTertiary__ApQ-M:hover:enabled {\n  background: #f1f1f1;\n  color: #23448d;\n}\n.button-module_buttonTertiary__ApQ-M:active:enabled {\n  background: transparent;\n  color: #00253e;\n}\n.button-module_buttonTertiaryActive__kF22A {\n  background: transparent;\n  color: #00253e;\n}\n";
var styles$2 = {"button":"button-module_button__RiZd-","buttonLarge":"button-module_buttonLarge__dZdJ6 button-module_button__RiZd-","buttonLargeIcon":"button-module_buttonLargeIcon__5xUfs button-module_button__RiZd-","buttonRegular":"button-module_buttonRegular__6-2hG button-module_button__RiZd-","buttonRegularIcon":"button-module_buttonRegularIcon__DTRqn button-module_button__RiZd-","buttonSmall":"button-module_buttonSmall__4v4PR button-module_button__RiZd-","buttonSmallIcon":"button-module_buttonSmallIcon__NrRV0 button-module_button__RiZd-","buttonPrimary":"button-module_buttonPrimary__tlsxX","buttonPrimaryNavy":"button-module_buttonPrimaryNavy__gutLQ button-module_buttonPrimary__tlsxX","buttonPrimaryNavyActive":"button-module_buttonPrimaryNavyActive__j-gy-","buttonPrimaryGold":"button-module_buttonPrimaryGold__H33XD button-module_buttonPrimary__tlsxX","buttonPrimaryGoldActive":"button-module_buttonPrimaryGoldActive__f-RQl","buttonPrimaryDanger":"button-module_buttonPrimaryDanger__fltR6 button-module_buttonPrimary__tlsxX","buttonPrimaryDangerActive":"button-module_buttonPrimaryDangerActive__ASUin","buttonSecondary":"button-module_buttonSecondary__Svb9S","buttonSecondaryActive":"button-module_buttonSecondaryActive__f4cwx","buttonTertiary":"button-module_buttonTertiary__ApQ-M","buttonTertiaryActive":"button-module_buttonTertiaryActive__kF22A"};
styleInject(css_248z$2,{"insertAt":"top"});

var css_248z$1 = "@keyframes IconLoading-module_spin__8T1oe {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.IconLoading-module_loading__tVp1l {\n  animation: IconLoading-module_spin__8T1oe 2s linear infinite;\n}\n";
var styles$1 = {"loading":"IconLoading-module_loading__tVp1l","spin":"IconLoading-module_spin__8T1oe"};
styleInject(css_248z$1,{"insertAt":"top"});

const IconLoading = () => (React__default.createElement("svg", { className: styles$1.loading, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React__default.createElement("path", { opacity: "0.2", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z", fill: "currentColor" }),
    React__default.createElement("path", { d: "M6.12215 20.0902C4.75945 19.1001 3.66891 17.7819 2.95173 16.2578C2.23455 14.7337 1.91397 13.0532 2.01973 11.3721L4.01579 11.4977C3.93118 12.8425 4.18764 14.187 4.76138 15.4062C5.33513 16.6255 6.20756 17.6801 7.29772 18.4721L6.12215 20.0902Z", fill: "currentColor" })));

const Button = ({ id, className, buttonStyle = 'primaryNavy', size = 'large', type = 'button', disabled = false, loading = false, active = false, onClick, children, ...rest }) => {
    const buttonClassName = classnames(className, {
        [getButtonSizeClassName(size)]: true,
        [getButtonStyleClassName(buttonStyle)]: true,
        [getButtonActiveClassName(buttonStyle)]: active,
    });
    return (React__default.createElement("button", { id: id, type: type, onClick: !loading && !disabled ? onClick : void 0, "aria-disabled": disabled, disabled: disabled, className: buttonClassName, ...rest }, loading ? React__default.createElement(IconLoading, null) : children));
};
const getButtonSizeClassName = (b) => {
    switch (b) {
        case 'large':
            return styles$2.buttonLarge;
        case 'regular':
            return styles$2.buttonRegular;
        case 'small':
            return styles$2.buttonSmall;
        case 'largeIcon':
            return styles$2.buttonLargeIcon;
        case 'regularIcon':
            return styles$2.buttonRegularIcon;
        case 'smallIcon':
            return styles$2.buttonSmallIcon;
    }
};
const getButtonStyleClassName = (b) => {
    switch (b) {
        case 'primaryNavy':
            return styles$2.buttonPrimaryNavy;
        case 'primaryGold':
            return styles$2.buttonPrimaryGold;
        case 'primaryDanger':
            return styles$2.buttonPrimaryDanger;
        case 'tertiary':
            return styles$2.buttonTertiary;
        case 'secondary':
            return styles$2.buttonSecondary;
    }
};
const getButtonActiveClassName = (b) => {
    switch (b) {
        case 'primaryNavy':
            return styles$2.buttonPrimaryNavyActive;
        case 'primaryGold':
            return styles$2.buttonPrimaryGoldActive;
        case 'primaryDanger':
            return styles$2.buttonPrimaryDangerActive;
        case 'tertiary':
            return styles$2.buttonTertiaryActive;
        case 'secondary':
            return styles$2.buttonSecondaryActive;
    }
};

/* This file is generated, changes will get overwritten */
const SvgMenuThreeDots24 = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", "aria-label": "Three Dots", viewBox: "0 0 24 24", ...props },
    React.createElement("circle", { cx: 12, cy: 5, r: 1.5, stroke: "#00253E" }),
    React.createElement("circle", { cx: 12, cy: 12, r: 1.5, stroke: "#00253E" }),
    React.createElement("circle", { cx: 12, cy: 19, r: 1.5, stroke: "#00253E" })));

var css_248z = ".dropdown-module_dropdown__BBQ2u {\n  display: inline-block;\n  position: relative;\n}\n.dropdown-module_dropdownActions__IOCF4 {\n  background-color: #ffffff;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  font-family: benton-sans, sans-serif;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0px;\n  max-height: 256px;\n  min-width: 240px;\n  position: absolute;\n  z-index: 10;\n}\n.dropdown-module_dropdownActionsTopLeft__vkcwd {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  bottom: 100%;\n  right: 0px;\n  top: auto;\n}\n.dropdown-module_dropdownActionsTopRight__ohdYn {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  bottom: 100%;\n  left: 0px;\n  top: auto;\n}\n.dropdown-module_dropdownActionsBottomLeft__e5wCQ {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  right: 0px;\n}\n.dropdown-module_dropdownActionsBottomRight__8nPWV {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  left: 0px;\n}\n.dropdown-module_dropdownAction__fo-Ei {\n  align-items: center;\n  background-color: inherit;\n  border-radius: 0px;\n  border-style: none;\n  color: #333333;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: inherit;\n  font-size: inherit;\n  height: 40px;\n  line-height: inherit;\n  outline-style: none;\n  padding: 8px 16px;\n  width: 100%;\n}\n.dropdown-module_dropdownAction__fo-Ei:first-of-type {\n  margin-top: 8px;\n}\n.dropdown-module_dropdownAction__fo-Ei:last-of-type {\n  margin-bottom: 8px;\n}\n.dropdown-module_dropdownAction__fo-Ei:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.dropdown-module_dropdownAction__fo-Ei:hover {\n  background-color: #f1f1f1;\n}\n.dropdown-module_dropdownAction__fo-Ei:focus {\n  background-color: #f1f1f1;\n}\n.dropdown-module_dropdownDivider__hvHue {\n  border-bottom: 1px solid #e7e7e7;\n  margin: 8px 16px;\n}\n";
var styles = {"dropdown":"dropdown-module_dropdown__BBQ2u","dropdownActions":"dropdown-module_dropdownActions__IOCF4","dropdownActionsTopLeft":"dropdown-module_dropdownActionsTopLeft__vkcwd","dropdownActionsTopRight":"dropdown-module_dropdownActionsTopRight__ohdYn","dropdownActionsBottomLeft":"dropdown-module_dropdownActionsBottomLeft__e5wCQ","dropdownActionsBottomRight":"dropdown-module_dropdownActionsBottomRight__8nPWV","dropdownAction":"dropdown-module_dropdownAction__fo-Ei","dropdownDivider":"dropdown-module_dropdownDivider__hvHue"};
styleInject(css_248z,{"insertAt":"top"});

const DropdownAction = ({ id, className, type = 'button', disabled = false, onClick, children, ...rest }) => {
    const dropdownActionClassName = classnames(className, {
        [styles.dropdownAction]: true,
    });
    return (React__default.createElement("button", { id: id, role: "option", type: type, onClick: onClick, "aria-disabled": disabled, disabled: disabled, className: dropdownActionClassName, ...rest }, children));
};

const DropdownDivider = ({ className }) => (React__default.createElement("div", { className: classnames([styles.dropdownDivider, className]) }));

const useClickOutside = (isExpanded) => {
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(isExpanded);
    const handleClickOutside = (e) => {
        const cur = ref.current;
        if (cur && !cur.contains(e.target)) {
            setExpanded(false);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    });
    return { ref, expanded, setExpanded };
};
const Dropdown = ({ id, alignment = 'bottomRight', ariaLabel = 'Options', className, disabled = false, buttonSize = 'regularIcon', buttonStyle = 'secondary', buttonChildren = React__default.createElement(SvgMenuThreeDots24, null), disablePropagation = true, children, }) => {
    const { ref, expanded, setExpanded } = useClickOutside(false);
    const dropdownClassName = classnames(className, {
        [styles.dropdown]: true,
    });
    const dropdownActionsClassName = classnames({
        [styles.dropdownActions]: true,
        [styles.dropdownActionsTopLeft]: alignment == 'topLeft',
        [styles.dropdownActionsTopRight]: alignment == 'topRight',
        [styles.dropdownActionsBottomLeft]: alignment == 'bottomLeft',
        [styles.dropdownActionsBottomRight]: alignment == 'bottomRight',
    });
    return (React__default.createElement("div", { id: id, className: dropdownClassName, "aria-haspopup": "true", "aria-expanded": expanded },
        React__default.createElement("div", { ref: ref },
            React__default.createElement(Button, { id: id + '_button', type: "button", "aria-label": ariaLabel, buttonStyle: buttonStyle, size: buttonSize, disabled: disabled, onClick: (event) => {
                    if (disablePropagation) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                    setExpanded(!expanded);
                } }, buttonChildren)),
        expanded ? (React__default.createElement("div", { id: id + '_actions', role: "listbox", className: dropdownActionsClassName }, children)) : null));
};
Dropdown.Action = DropdownAction;
Dropdown.Divider = DropdownDivider;

export { Dropdown };
//# sourceMappingURL=index.es.js.map
